export default __webpack_public_path__ + "static/media/speaker-mute.635ebb78.svg";